var WAVECHAT = new function() {
	// "use strict";
	
  // this.ws_url = '@api.chat.url@';
  this.ws_url = process.env.REACT_APP_CHAT_API_URL;
	
	this.entrprs_code = "";
	this.ir_code = "";
	this.user_id = "";
	this.user_ty = "0";
	this.tkn = "";
	
	this.debug = true;
	
	var isLogin = false;
	var webSocket;
	
	this.PacketTypes = {
			PTG_IMS_LOGIN 				 : "0x00010000",
			PTG_IMS_CHATROOM 			 : "0x00040000",
			PTG_IMS_CHAT 				 : "0x00050000",
			PTG_IMS_IR			         : "0x00100000",
			
			PTC_IMS_LOGIN_LOGIN	         : "0x00010001",
			PTC_IMS_CHATROOM_ENTER_ROOM  : "0x00040014",
			PTC_IMS_CHAT_LIST			 : "0x00050001",
			PTC_IMS_CHAT_SEND_MSG        : "0x00050002",
			PTC_IMS_CHAT_READ            : "0x00050005",
			PTC_IMS_CHAT_RECV_MSG        : "0x00050006",
			PTC_IMS_IR_ACTION			 : "0x00100001",
      
      PTG_COP                   : "0x00610000",
      PTC_COP_MSG_CONTROL       : "0x00610001",
		}
			
	function log(logStr) {
		if (WAVECHAT.debug)
			console.log('WAVECHAT: ' + logStr);
	}
	
	this.getIsLogin = function() {
		return isLogin;
	}
	
	this.open = function() {
		webSocket = new WebSocket(this.ws_url);
		
	    webSocket.onopen = function(event) {
	    	log("ws onopen");
	    	if (WAVECHAT.onopen instanceof Function)
	    		WAVECHAT.onopen(event);
	    	WAVECHAT.login();
		};
		
	    webSocket.onerror = function(event) {
	    	log("ws onerror");
	    	if (WAVECHAT.onerror instanceof Function)
	    		WAVECHAT.onerror(event);
	    };	
		    
		webSocket.onclose = function(event) {
			log("ws onclose");
			try {
		    	if (WAVECHAT.onclose instanceof Function)
		    		WAVECHAT.onclose(event);
			} catch (err) {
				//
			}
			isLogin = false;
		}
		
	    webSocket.onmessage = function(event) {
	    	log("ws onmessage, data:" + event.data);
	    	onmessage(event);
	    };
	}
	
	this.close = function() {
		webSocket.close();
	}
	
	this.send = function(packet) {
		try {
		    if (webSocket != null)
		    	webSocket.send(packet.toString());
		}
		catch(err) {
		    // 
		} 
	}
	
	this.Packet = function(ptg, ptc) {
		this.json = {
      ptg: ptg,
      ptc: ptc,
    };
		
		this.toString = function() {
			return JSON.stringify(this.json);
		}
	}
	
	this.login = function() {
		var packet = new this.Packet(WAVECHAT.PacketTypes.PTG_IMS_LOGIN, WAVECHAT.PacketTypes.PTC_IMS_LOGIN_LOGIN);
		
        var jParams = {
          entrprs_code: this.entrprs_code,
          ir_code: this.ir_code,
          user_id: this.user_id,
          user_ty: this.user_ty,
          tkn: this.tkn,
        }
        packet.json.params = jParams;		
         
        this.send(packet.toString());
	}

	function onmessage(event) {
		try {
	    	var data = JSON.parse(event.data);
	    	// var params = data.params;
	    	
	    	switch (data.ptc) {
	    		
		    	case WAVECHAT.PacketTypes.PTC_IMS_LOGIN_LOGIN : 	    		
		    		if (data.result === "success") {
		    			isLogin = true;
		    			log('login ok');
				    	if (WAVECHAT.onlogin instanceof Function)
				    		WAVECHAT.onlogin(true, data, '');
		    		} else if (data.result === "error") {
		    			isLogin = false;
		    			WAVECHAT.close(); 
				    	if (WAVECHAT.onlogin instanceof Function)
				    		WAVECHAT.onlogin(false, data.result, data.reason);
		    		} 
	    			 
		    		break;
		    		
	    		default :
	    	    	//if (isLogin) {
	    		    	if (WAVECHAT.onmessage instanceof Function) {
	    		    		WAVECHAT.onmessage(JSON.parse(event.data));
	    	    		}
	    	    	//}
	    			break;
	    	}
	    	
		} catch(err) {
			log(err);
		}
	}

	
}();



export default WAVECHAT;